export enum ContextMenuTargetType {
  EmailAccount = 'EmailAccount',
}

export enum ContextMenuActionKey {
  BlockSender = 'block_sender',
  DisableUserAccount = 'disable_user_account',
  SignOut = 'sign_out',
  ResetPassword = 'reset_password',
}

export enum ContextMenuActionType {
  PopUp = 'popup',
}

export interface ContextMenuItem {
  target_type: ContextMenuTargetType;
  action_key: ContextMenuActionKey;
  action_url: string;
  action_type: ContextMenuActionType;
  name: string;
  [key: string]: any;
}
